// Set element in DOM
document.body.innerHTML += '<i class="js_resolution"></i>';
function resolutionCheck() {
  const $res = document.getElementsByClassName('js_resolution')[0];
  return window.getComputedStyle($res, null).getPropertyValue('opacity');
}